// FetchPosts.js
import React from 'react';
import { useFetchPosts } from '../hooks/DataFetching/useFetchPosts';

export const FetchPosts = () => {
    const { posts, loading } = useFetchPosts();

    const renderPostsTable = (posts) => {
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>userId</th>
                        <th>topicId</th>
                        <th>atUserId</th>
                        <th>atPostId</th>
                        <th>atPositionId</th>
                        <th>atCampaignId</th>
                        <th>postDate</th>
                        <th>body</th>
                        <th>likes</th>
                        <th>replies</th>
                        <th>createdOn</th>
                    </tr>
                </thead>
                <tbody>
                    {posts.map(post =>
                        <tr key={post.id}>
                            <td>{post.id}</td>
                            <td>{post.userId}</td>
                            <td>{post.topicId}</td>
                            <td>{post.atUserId}</td>
                            <td>{post.atPostId}</td>
                            <td>{post.atPositionId}</td>
                            <td>{post.atCampaignId}</td>
                            <td>{post.postDate}</td>
                            <td>{post.body}</td>
                            <td>{post.likes}</td>
                            <td>{post.replies}</td>
                            <td>{post.createdOn}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    };

    let contents = loading ? (
        <p>
            <em>Loading...</em>
        </p>
    ) : renderPostsTable(posts);

    return (
        <div>
            <h1 id="tabelLabel">Posts</h1>
            <p>This component demonstrates fetching data from the server.</p>
            {contents}
        </div>
    );
};
